import TermsAndConditions from "../components/TermsAndConditions";

const TermsAndConditionsPage = () => {
  return <TermsAndConditions />;
};

export default TermsAndConditionsPage;
